module.exports = __webpack_public_path__ + "static/media/plan_english.3afc304b.png";